export default __webpack_public_path__ + "static/media/author.bd970665.png";